import React, { useContext, useState, useEffect } from 'react';
import { SPOILER_TYPE } from 'ricos-content';
import { RicosContext, ModalContext, EditorContext, PluginsContext } from 'ricos-context';
import { videoModals } from '../constants.js';
import { VideoSettings } from './VideoSettings.js';
import { VIDEO_TYPE } from '../types.js';
import 'ricos-schema';
import '@wix/design-system';
import 'wix-rich-content-ui-components';
import '../dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SettingsModal = ({ nodeId }) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const plugins = useContext(PluginsContext);
  const spoilerPlugin = plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
  const shouldShowSpoiler = spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(VIDEO_TYPE));
  const [initialData, setInitialData] = useState();
  const [componentData, setComponentData] = useState();
  useEffect(() => {
    const componentData2 = getEditorCommands().getBlockComponentData(nodeId);
    setInitialData(componentData2);
    setComponentData(componentData2);
  }, []);
  const updateData = (data) => {
    getEditorCommands().setBlock(nodeId, VIDEO_TYPE, __spreadProps(__spreadValues(__spreadValues({}, componentData), data), { id: nodeId }));
    setComponentData(__spreadValues(__spreadValues({}, componentData), data));
  };
  const closeModal = () => {
    modalService.closeModal(videoModals.settings);
  };
  const onCancel = () => {
    updateData(initialData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    VideoSettings,
    {
      componentData,
      helpers: {},
      t,
      isMobile,
      updateData,
      onSave: closeModal,
      onCancel,
      shouldShowSpoiler
    }
  ) : null;
};

export { SettingsModal };
//# sourceMappingURL=SettingsModal.js.map
